/**
 * cfgscale-1
 */

import { cfgScale1Atom } from './atom'
import { createSliderInputComponent } from './_createSliderInputComponent'

const CfgScale1 = createSliderInputComponent(
  {
    label: 'CFG Scale-1',
    atom: cfgScale1Atom,
    helpContent:
      '绘画第一阶段的提示词相关性（CFG scale），即AI对描述参数的倾向程度',
    min: 1,
    max: 30,
    step: 0.5,
    digits: 1,
  },
  'CfgScale1'
)

export { CfgScale1 }
